import { useMutation } from '@tanstack/react-query'
import defaultConfig from 'const/config'
import {
  AuthenticateMutationResult,
  AuthenticateUseMutationProps
} from './authenticateMutation.types'
import { getAuthenticateMutationOptions } from './authenticateMutationOptions'

const defaultOptions = { config: defaultConfig }

/**
 * Calls the pii-authenticate endpoint which is used to signin the user and check if their
 * PII (aka phone number and last 4 SSN) match what's in the user database. Slight variation
 * on /authenticate but should have pretty similar inputs
 * https://developer.syf.com/internal-api-reference/credit-accounts-identity-v1#operation/Authenticate
 * @param props @see {@link AuthenticateUseMutationProps} - options for the Authenticate query
 * @returns the same as useMutation returns, an obj with .data and other query stuff
 */
const useAuthenticateMutation = (
  props: AuthenticateUseMutationProps = defaultOptions
): AuthenticateMutationResult => {
  const authenticateMutationOptions = getAuthenticateMutationOptions(props)

  return useMutation(authenticateMutationOptions)
}

export default useAuthenticateMutation
